// admin Api
import request from "@/config/_request";
import qs from "qs";

const admin = true;

//超管添加或编辑题目来源
export function adminAddOrUpdateOjProblemSource(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problem/source",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题目来源列表
export function adminGetOjProblemSourceList(params) {
    return request({
        url: "/api/admin/get/oj/problem/source/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除题目来源
export function adminDeleteOjProblemSource(params) {
    return request({
        url: "/api/admin/delete/oj/problem/source",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管添加或编辑题目难度
export function adminAddOrUpdateOjProblemDifficulty(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problem/difficulty",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题目难度列表
export function adminGetOjProblemDifficultyList(params) {
    return request({
        url: "/api/admin/get/oj/problem/difficulty/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除题目难度
export function adminDeleteOjProblemDifficulty(params) {
    return request({
        url: "/api/admin/delete/oj/problem/difficulty",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管添加或编辑算法分组
export function adminAddOrUpdateOjProblemTagGroup(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problem/tag/group",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得算法标签分组列表
export function adminGetOjProblemTagGroupList(params) {
    return request({
        url: "/api/admin/get/oj/problem/tag/group/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除算法分组
export function adminDeleteOjProblemTagGroup(params) {
    return request({
        url: "/api/admin/delete/oj/problem/tag/group",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管添加或编辑算法标签
export function adminAddOrUpdateOjProblemTag(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problem/tag",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题目算法标签列表
export function adminGetOjProblemTagList(params) {
    return request({
        url: "/api/admin/get/oj/problem/tag/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除算法标签
export function adminDeleteOjProblemTag(params) {
    return request({
        url: "/api/admin/delete/oj/problem/tag",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管添加或更新题目
export function adminAddOrUpdateOjProblem(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problem",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管添加或更新题单
export function adminAddOrUpdateOjProblemList(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problemlist",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题目列表
export function adminGetOjProblemList(params) {
    return request({
        url: "/api/admin/get/oj/problem/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管更新题目可见状态
export function adminUpdateOjProblemVisible(params) {
    return request({
        url: "/api/admin/update/oj/problem/visible",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}

//超管获得题单列表
export function adminGetOjProblemListList(params) {
    return request({
        url: "/api/admin/get/oj/problemlist/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除题目题单
export function adminDeleteOjProblemList(params) {
    return request({
        url: "/api/admin/delete/oj/problemlist",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管给题单添加问题页面获得题目列表,去除了题单已包含的题目
export function adminGetOjProblemListForProblemList(params) {
    return request({
        url: "/api/admin/get/oj/problemlist/for/problemlist/add/problem",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管给题单添加问题
export function adminAddProblemForProblemList(params) {
    return request({
        url: "/api/admin/add/oj/problem/for/problemlist",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题单题目列表
export function adminGetProblemForProblemList(params) {
    return request({
        url: "/api/admin/get/oj/problem/for/problemlist",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除题单
export function adminDeleteProblemForProblemList(params) {
    return request({
        url: "/api/admin/delete/oj/problem/for/problemlist",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管添加或更新比赛
export function adminAddOrUpdateOjContest(params) {
    return request({
        url: "/api/admin/add/or/update/oj/contest",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得比赛列表
export function adminGetOjContestList(params) {
    return request({
        url: "/api/admin/get/oj/contest/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除比赛
export function adminDeleteOjContest(params) {
    return request({
        url: "/api/admin/delete/oj/contest",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管给比赛添加问题页面获得题目列表,去除了比赛中已包含的题目
export function adminGetOjProblemListGame(params) {
    return request({
        url: "/api/admin/get/oj/problem/list/for/contest/add/problem",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管给比赛添加问题
export function adminAddProblemForContest(params) {
    return request({
        url: "/api/admin/add/problem/for/contest",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得比赛题目列表
export function adminGetProblemForContest(params) {
    return request({
        url: "/api/admin/get/problem/for/contest",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管给比赛删除问题
export function adminDeleteProblemForContest(params) {
    return request({
        url: "/api/admin/delete/problem/for/contest",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管更新题目公开状态
export function adminUpdateOjProblemPublic(params) {
    return request({
        url: "/api/admin/update/oj/problem/public",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得比赛用户列表
export function adminGetOjContestSignList(params) {
    return request({
        url: "/api/admin/get/contest/sign/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管比赛添加学生页面获得学生列表
export function adminGetStuListForAddContestUser(params) {
    return request({
        url: "/api/admin/get/stu/list/for/add/contest/user",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管比赛添加教师页面获得列表
export function adminGetUserListForAddContestUser(params) {
    return request({
        url: "/api/admin/get/user/list/for/add/contest/user",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管为比赛添加学生接口
export function adminAddContestSign(params) {
    return request({
        url: "/api/admin/add/contest/sign",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//更新学生审核状态接口
export function adminUpdateContestSignCheckState(params) {
    return request({
        url: "/api/admin/update/contest/sign/check/state",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//移除比赛用户报名信息接口
export function adminDeleteContestSign(params) {
    return request({
        url: "/api/admin/delete/contest/sign",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题目信息
export function adminGetOjProblemInfoById(params) {
    return request({
        url: "/api/admin/get/oj/problem/info/by/id",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//spj编译接口

export function compileSpj(params) {
    return request({
        url: "/api/spj-compilation",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管更新比赛题目排序号
export function adminUpdateContestProblemSortNum(params) {
    return request({
        url: "/api/admin/update/contest/problem/sortnum",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管删除题目
export function adminDeleteOjProblem(params) {
    return request({
        url: "/api/admin/delete/oj/problem",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管添加或编辑题解
export function adminAddOrUpdateOjProblemAnalysis(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problem/analysis",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题目题解列表
export function adminGetOjProblemAnalysisList(params) {
    return request({
        url: "/api/admin/get/oj/problem/analysis/list",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//超管删除解析
export function adminDeleteOjProblemAnalysis(params) {
    return request({
        url: "/api/admin/delete/problem/analysis",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管设置题目解析的类型
export function adminUpdateOjProblemAnalysisSortType(params) {
    return request({
        url: "/api/admin/update/problem/analysis/sorttype",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管设置题目解析是否可见
export function adminUpdateOjProblemAnalysisVisible(params) {
    return request({
        url: "/api/admin/update/problem/analysis/visible",
        data: qs.stringify(params),
        method: "post",
        admin
    });
}
//超管获得题单题目列表不分页
export function adminGetProblemForProblemListSort(params) {
    return request({
        url: "/api/admin/get/oj/problem/for/problemlist/sort",
        params,
        method: "get",
        admin,
        noLoading: false
    });
}
//获得问题难度列表
export function getOjProblemDifficultyList(params) {
    return request({
        url: "/api/oj/get/oj/problem/difficulty/list",
        params,
        method: "get",
        admin,
    });
}
//获得问题分组列表
export function getOjProblemTagGroupList(params) {
    return request({
        url: "/api/oj/get/oj/problem/tag/group/list",
        params,
        method: "get",
        admin,

    });
}
//获得问题来源列表
export function getOjProblemSourceList(params) {
    return request({
        url: "/api/oj/get/oj/problem/source/list",
        params,
        method: "get",
        admin,

    });
}
//更新题单题目排序
export function tchUpdateProblemSortOfPorblemList(params) {
    return request({
        url: "/api/tch/updateProblemSortOfPorblemList",
        data: qs.stringify(params),
        method: "post",
        admin,

    });
}
//超管添加或编辑题单类型
export function adminAddOrUpdateOjProblemListType(params) {
    return request({
        url: "/api/admin/add/or/update/oj/problemlisttype",
        data: qs.stringify(params),
        method: "post",
        admin,

    });
}
//获得问题来源列表
export function adminGetOjProblemListTypeList(params) {
    return request({
        url: "/api/admin/get/oj/problemlisttype/list",
        params,
        method: "get",
        admin,

    });
}
//超管删除题单类型
export function adminDeleteOjProblemListType(params) {
    return request({
        url: "/api/admin/delete/oj/problemlisttype",
        data: qs.stringify(params),
        method: "post",
        admin,

    });
}
//不分页查询题单类型列表
export function adminGetOjProblemListTypeListWithOutP(params) {
    return request({
        url: "/api/admin/get/oj/problemlisttype/list/WithOutPage",
        params,
        method: "get",
        admin,

    });
}